"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadState = void 0;
var axios_1 = __importDefault(require("axios"));
var GetPercentAfterUpload_1 = __importStar(require("./GetPercentAfterUpload"));
var UploadUtils_1 = __importDefault(require("Common/Upload/UploadUtils"));
var IMAGE_MAX_FILE_SIZE_IN_MB = 30;
var UploadState;
(function (UploadState) {
    UploadState["Pending"] = "pending";
    UploadState["Success"] = "success";
    UploadState["Error"] = "error";
})(UploadState || (exports.UploadState = UploadState = {}));
var UploadService = (function () {
    function UploadService(apiBaseUrl, modal) {
        var _this = this;
        this.apiBaseUrl = apiBaseUrl;
        this.modal = modal;
        this.upload = function (_a, updateUploadProgress_1) { return __awaiter(_this, [_a, updateUploadProgress_1], void 0, function (_b, updateUploadProgress) {
            var interval, formData, response, uploadResponse, error_1;
            var _this = this;
            var _c;
            var file = _b.file, folderId = _b.folderId;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        interval = 0;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        if (UploadUtils_1.default.isImage(file)) {
                            this.loadImageLocally(file, updateUploadProgress);
                        }
                        formData = new FormData();
                        formData.append("file", file, file.name);
                        if (folderId !== undefined) {
                            formData.append("updateIfDuplicate", "true");
                        }
                        if (!!folderId) {
                            formData.append("folderId", folderId);
                        }
                        return [4, axios_1.default.post("".concat(this.apiBaseUrl, "/").concat(UploadUtils_1.default.getEndpoint(file)), formData, {
                                withCredentials: true,
                                onUploadProgress: function (event) {
                                    if (event.lengthComputable) {
                                        updateUploadProgress({
                                            state: UploadState.Pending,
                                            percent: Math.floor((event.loaded / event.total) * GetPercentAfterUpload_1.END_OF_UPLOAD_PERCENT),
                                        });
                                        if (event.loaded === event.total) {
                                            interval = _this.progressServerLoad(updateUploadProgress);
                                        }
                                    }
                                },
                            })];
                    case 2:
                        response = _d.sent();
                        this.stopServerLoadProgresser(interval);
                        uploadResponse = (_c = response === null || response === void 0 ? void 0 : response.data[0]) !== null && _c !== void 0 ? _c : undefined;
                        updateUploadProgress({
                            state: UploadState.Success,
                            percent: 100,
                            url: this.getUrlFromResponse(file, response),
                            uploadResponse: uploadResponse,
                        });
                        return [3, 4];
                    case 3:
                        error_1 = _d.sent();
                        this.stopServerLoadProgresser(interval);
                        updateUploadProgress({
                            state: UploadState.Error,
                            percent: 0,
                        });
                        throw error_1;
                    case 4: return [2];
                }
            });
        }); };
        this.progressServerLoad = function (updateUploadProgress) {
            var i = 0;
            return window.setInterval(function () {
                updateUploadProgress({
                    percent: (0, GetPercentAfterUpload_1.default)(++i),
                });
            }, 500);
        };
        this.loadImageLocally = function (file, updateUploadProgress) {
            return new Promise(function (resolve) {
                var reader = new FileReader();
                reader.onload = function (event) {
                    if (event.target == null) {
                        return;
                    }
                    var dataUrl = event.target.result;
                    updateUploadProgress({
                        dataUrl: dataUrl,
                    });
                    resolve(dataUrl);
                };
                reader.readAsDataURL(file);
            });
        };
    }
    UploadService.prototype.validateFileUpload = function (_a) {
        var file = _a.file, folderId = _a.folderId;
        var isImageFile = UploadUtils_1.default.isImage(file);
        if (!isImageFile && !UploadUtils_1.default.isDocx(file) && !UploadUtils_1.default.isFont(file)) {
            throw new Error("Only support font, image and docx");
        }
        if (isImageFile) {
            if (UploadUtils_1.default.islargeFile(file, IMAGE_MAX_FILE_SIZE_IN_MB * 1000)) {
                var errorMessage = "Try a file with a size smaller than ".concat(IMAGE_MAX_FILE_SIZE_IN_MB, "MB.");
                this.modal.showAcknowledgeModal({
                    title: "Whoops, file is too big!",
                    explainer: errorMessage,
                });
                throw new Error(errorMessage);
            }
            if (UploadUtils_1.default.isTiff(file)) {
                this.modal.showAcknowledgeModal({
                    title: "TIFF files are not supported",
                    explainer: "TIFF files do not display correctly on most browsers. Try converting the image to a JPEG or PNG file",
                });
                throw new Error("TIFF files are not supported");
            }
        }
        if (!isImageFile && !!folderId) {
            throw new Error("File does not support being moved into a folder");
        }
    };
    UploadService.prototype.getUrlFromResponse = function (file, response) {
        if (UploadUtils_1.default.isDocx(file)) {
            return response.data;
        }
        else if (UploadUtils_1.default.isFont(file)) {
            return response.data ? response.data.url : "";
        }
        else if (UploadUtils_1.default.isImage(file)) {
            return response.data[0] ? response.data[0].url : "";
        }
    };
    UploadService.prototype.stopServerLoadProgresser = function (interval) {
        return clearInterval(interval);
    };
    return UploadService;
}());
exports.default = UploadService;
